import { Typography, Fab } from "@mui/material";
import { styled } from '@mui/material/styles';
import { TfiDownload } from "react-icons/tfi";

const CustomFab = styled(Fab)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 16px',
    width: '174px',
    height: '44px',
    background: 'rgba(255, 255, 255, 0.15)',
    borderRadius: '100px',
    color: 'white', // Assuming you want white text
    boxShadow: 'none', // Remove the default shadow effect
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.25)', // Adjust hover background
    }
  });

  export default function DownloadPDFButton({ pdfDownloadUrl, pdfName='report.pdf' }) {
    const handleDownload = () => {
      fetch(pdfDownloadUrl)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement('a');
        const blobUrl = URL.createObjectURL(blob);
        link.href = blobUrl;
        link.setAttribute('download', pdfName);

        // Append the anchor to the DOM and trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl); // Release the blob URL
      })
      .catch(err => console.error('Error while downloading the file:', err));
    };
    
    
    return (
      <CustomFab variant="extended" onClick={handleDownload}>
        <TfiDownload/>
        <Typography variant="body" color="white" ml="8px" style={{ textTransform: 'none' }}>
          Download PDF
        </Typography>
      </CustomFab>
    );
  }